import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const AirplaneRealIcon = ({
  title = 'Airplane',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 64 64" {...props}>
    {/* prettier-ignore */}
    <path d="M32.053 50.884 22.415 56v-3.492l4.994-5.205V34.935L10 41.715v-3.37l17.5-12.66V12.553s.003-1.476.852-2.747c.633-.947 1.736-1.78 3.656-1.805a.984.984 0 0 1 .09-.001c1.92.026 3.022.859 3.655 1.806.85 1.27.853 2.747.853 2.747v13.132l17.5 12.66v3.37l-17.41-6.78v12.368l4.994 5.205V56l-9.637-5.116Z" fillRule="evenodd" strokeLinejoin="round" />
  </CreateIconComponent>
);

export default AirplaneRealIcon;
